import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getBookingWidgetRoomData = createAsyncThunk(
    'booking-widget/get-room-data',
    async (params = {}) => {
        let url = params.roomsUrl;
        const sortBy = params.sortBy || '';

        let urlParts = url.split('&');

        // When sortBy is provided replace the sort query parameter with the
        // one selected by the user
        if (sortBy) {
            urlParts = urlParts.map((urlPart) => {
                if (urlPart.startsWith('sort')) {
                    return `sort=${sortBy}`;
                } else {
                    return urlPart;
                }
            });

            url = urlParts.join('&');
        }

        const response = await axios.get(url);

        return response.data;
    }
);

export const bookingWidgetRoomsSlice = createSlice({
    name: 'rooms',
    initialState: {
        roomTypes: [],
        selectedRoom: null,
        selectedRoomIndex: null,
        isDrawerOpen: false,
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
    },
    reducers: {
        setSelectedRoom: (state, action) => {
            state.selectedRoomIndex = action.payload.selectedRoomIndex;
        },
    },
    extraReducers: {
        [getBookingWidgetRoomData.fulfilled]: (state, { payload }) => {
            state.roomTypes = payload.roomTypes || [];
            state.isFetching = false;
            state.isSuccess = true;
            state.isError = false;
            state.errorMessage = '';
        },
        [getBookingWidgetRoomData.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = true;
            state.errorMessage = '';
        },
        [getBookingWidgetRoomData.pending]: (state) => {
            state.isFetching = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = '';
        },
    },
});

export const { setSelectedRoom } = bookingWidgetRoomsSlice.actions;
